import { render, staticRenderFns } from "./TopfansXingTai.vue?vue&type=template&id=0e409935&scoped=true&"
import script from "./TopfansXingTai.vue?vue&type=script&lang=js&"
export * from "./TopfansXingTai.vue?vue&type=script&lang=js&"
import style0 from "./TopfansXingTai.vue?vue&type=style&index=0&id=0e409935&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e409935",
  null
  
)

export default component.exports